import { createRoute, lazyRouteComponent } from "@tanstack/react-router";

import { authenticatedRoute } from "../_authenticated.js";

export const engagementPlanRoute = createRoute({
  getParentRoute: () => authenticatedRoute,
  path: "/engagement-plan",
  component: lazyRouteComponent(() => import("./engagement-plan.page.js"), "EngagementPlanPage"),
});
